import MadeReservationsList from '@/pages/Dashboard/MadeReservationsList.vue';
import ReceivedReservationsList from '@/pages/Dashboard/ReceivedReservationsList.vue';
import IdentityVerificationReturn from '@/pages/Verification/IdentityVerificationReturn.vue';

export default [
    {
        // Adonde vuelve el huésped después de verificar su identidad en Didit.
        // Debe coincidir con DIDIT_CALLBACK_URL en el .env de hyf-api.
        path: '/verificacion-identidad/retorno',
        name: 'identity-verification-return',
        component: IdentityVerificationReturn,
        meta: {
            requiresAuth: true,
        }
    },
    {
        path: '/reservations-made',
        name: 'reservations-made',
        component: MadeReservationsList,
        meta: {
            requiresAuth: true,
            showDashboard: true,
        }
    },
    {
        path: '/reservations-received',
        name: 'reservations-received',
        component: ReceivedReservationsList,
        meta: {
            requiresAuth: true,
            showDashboard: true,
        }
    }
]